module.exports = {
	"_args": [
		[
			"websocket@1.0.33",
			"/vercel/path0"
		]
	],
	"_from": "websocket@1.0.33",
	"_id": "websocket@1.0.33",
	"_inBundle": false,
	"_integrity": "sha512-XwNqM2rN5eh3G2CUQE3OHZj+0xfdH42+OFK6LdC2yqiC0YU8e5UK0nYre220T0IyyN031V/XOvtHvXozvJYFWA==",
	"_location": "/web3/websocket",
	"_phantomChildren": {},
	"_requested": {
		"type": "version",
		"registry": true,
		"raw": "websocket@1.0.33",
		"name": "websocket",
		"escapedName": "websocket",
		"rawSpec": "1.0.33",
		"saveSpec": null,
		"fetchSpec": "1.0.33"
	},
	"_requiredBy": [
		"/web3/web3-providers-ws"
	],
	"_resolved": "https://registry.npmjs.org/websocket/-/websocket-1.0.33.tgz",
	"_spec": "1.0.33",
	"_where": "/vercel/path0",
	"author": {
		"name": "Brian McKelvey",
		"email": "theturtle32@gmail.com",
		"url": "https://github.com/theturtle32"
	},
	"browser": "lib/browser.js",
	"bugs": {
		"url": "https://github.com/theturtle32/WebSocket-Node/issues"
	},
	"config": {
		"verbose": false
	},
	"contributors": [
		{
			"name": "Iñaki Baz Castillo",
			"email": "ibc@aliax.net",
			"url": "http://dev.sipdoc.net"
		}
	],
	"dependencies": {
		"bufferutil": "^4.0.1",
		"debug": "^2.2.0",
		"es5-ext": "^0.10.50",
		"typedarray-to-buffer": "^3.1.5",
		"utf-8-validate": "^5.0.2",
		"yaeti": "^0.0.6"
	},
	"description": "Websocket Client & Server Library implementing the WebSocket protocol as specified in RFC 6455.",
	"devDependencies": {
		"buffer-equal": "^1.0.0",
		"gulp": "^4.0.2",
		"gulp-jshint": "^2.0.4",
		"jshint": "^2.0.0",
		"jshint-stylish": "^2.2.1",
		"tape": "^4.9.1"
	},
	"directories": {
		"lib": "./lib"
	},
	"engines": {
		"node": ">=4.0.0"
	},
	"homepage": "https://github.com/theturtle32/WebSocket-Node",
	"keywords": [
		"websocket",
		"websockets",
		"socket",
		"networking",
		"comet",
		"push",
		"RFC-6455",
		"realtime",
		"server",
		"client"
	],
	"license": "Apache-2.0",
	"main": "index",
	"name": "websocket",
	"repository": {
		"type": "git",
		"url": "git+https://github.com/theturtle32/WebSocket-Node.git"
	},
	"scripts": {
		"gulp": "gulp",
		"test": "tape test/unit/*.js"
	},
	"version": "1.0.33"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/web3/node_modules/websocket/package.json
// module id = 1026
// module chunks = 0